import { Button, Grid, Typography } from '@mui/material';
import Modal from './Modal';

type DeleteConfirmationModalProps = {
  entity: string;
  open: boolean;
  setOpen: (value: boolean) => void;
  onDelete: () => void;
};

export default function DeleteConfirmationModal(props: DeleteConfirmationModalProps) {
  return (
    <Modal title={`Delete ${props.entity}`} open={props.open} setOpen={props.setOpen}>
      <Grid container spacing={2} paddingTop={2} flexWrap={'nowrap'}>
        <Grid item xs={12}>
          <Typography>{`Are you sure you want to delete this ${props.entity}?`}</Typography>
        </Grid>
        <Grid item>
          <Button color={'error'} variant={'contained'} onClick={props.onDelete}>
            {`Delete ${props.entity}`}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
}
